module.exports = __webpack_public_path__ + "img/npt24.bd0ce2bd.png";